<template>
     <div>
        <div class="inst-title">Instructions about the Platform</div>
        <div class="inst-list">
        <div class="instr-block">
            <span>1.</span>
            <div class="instr-data">The countdown timer in the top right corner of the screen will display the time available for you to complete the examination. When the timer
            reaches zero, the examination will end itself. You will not be required to submit or end your examination.
            </div>
        </div>

        <div class="instr-block">
            <span>2.</span>
            <div class="instr-data">
            If you want to submit or end our examination before the timer reaches zero, you can do so by clicking on the <v-btn color="default" class="cust-btn mid-btn finish-test">Finish Test</v-btn> button at the
            bottom on the right corner of your screen.
            </div>
        </div>
        <div class="instr-block">
            <span>3.</span>
            <div class="instr-data">
            The Question Palette on the right side of your screen will show the status of each question using one of the following symbols:
            </div>
        </div>
        <div class="list-data">
            <ul>
                <li><span class="squre bg-gray"></span><span>Not Visited: Question you have not seen</span></li>
                <li><span class="squre bg-green"></span><span>Answered: Questions which you have answered.</span></li>
                <li><span class="squre bg-red"></span><span>Not Answered: Questions which you have seen but not answered.</span></li>
                <li><span class="squre bg-yellow"></span><span>Review Later: Questions which you have marked for review but not answered.</span></li>
                <li>
                    <span class="squre bg-green">
                        <span class="yel-doth"></span>
                    </span>
                    <span>
                    Answered and review later: Questions which you have answered and also marked for reviews.<br>
                    <span class="red-text-data">(Please note that these Questions will be considered for evaluation of your result.)</span></span>
                </li>
            </ul>
        </div>
        
        <div class="instr-block">
            <span>4.</span>
            <div class="instr-data">
            You can toggle between various subjects and the different type of questions in each subject by clicking on the respective buttons at the
            panel above the questions.
            </div>
        </div>
        <div class="instr-block">
            <span>5.</span>
            <div class="instr-data">
            You can toggle between different questions of a particular section of any subject by clicking on the question number in the Question Palette
            on the right side of your screen.
            </div>
        </div>
        <div class="instr-block">
            <span>6.</span>
            <div class="instr-data">
            Once you have answered a question, you must click on <v-btn color="primary" class="right-btn mid-btn cust-btn">Save & Next </v-btn> to save your response and move on to the next question.
            </div>
        </div>
        <div class="instr-block">
            <span>7.</span>
            <div class="instr-data">
            If you want to change your answer to any question, you need to go to that question, make the necessary changes in your response and click
            on <v-btn color="primary" class="right-btn mid-btn cust-btn">Save & Next </v-btn>
            </div>
        </div>
        <div class="instr-block">
            <span>8.</span>
            <div class="instr-data">
            If you want to remove your response to a question, you need to go to that question, and click on <v-btn color="#EFEEEE" class="btn-default mid-btn clear-reponse">Clear Response</v-btn> The corresponding
            question number in the Question Palette on the right shall turn <span class="redtxt-001">RED</span> indicating that your response has been cleared.
            </div>
        </div>  
        </div>
    </div>
</template>

<script>
export default {
    name: "TestDashboard",
    data: () => ({}),
    methods: {
        goBack() {
            this.$router.back();
        },
        showTestInstructions() {
            this.$parent.showCommonInstructions = false;
        }
    },
    mounted(){
        window.scrollTo(0, 0);
    }
};
</script>
